<template>
  <section :id="$style.about_medal_visual">
    <div :class="[$style.first_area, $style.area]">
      <main-title
        :class="$style.main_title"
        :main_title="'1. 日本シリーズMVPトロフィー'"
        :sub_title="'〜 2000年 〜'"
        :color="'#fff'"
        :align="'center'"
      ></main-title>
      <div :class="$style.caption">
        この年の日本シリーズは、長嶋監督率いる｢読売ジャイアンツ｣と王監督率いる｢ダイエーホークス｣の対戦となり、
        ｢ＯＮ対決｣としても大変注目を浴びました。結果は読売ジャイアンツが4勝2敗で勝利。6年ぶり19度目の日本一に輝きました。
        松井選手も3本塁打8打点と活躍し、最高殊勲選手賞ＭＶＰを獲得しました。
      </div>
      <div :class="[$style.fig1, $style.fig]"></div>
    </div>

    <div :class="[$style.second_area, $style.area]">
      <main-title
        :class="$style.main_title"
        :main_title="'2. ヤンキース日本開幕戦MVPトロフィー'"
        :sub_title="'〜 2004年3月30日・31日 〜'"
        :color="'#fff'"
        :align="'center'"
      ></main-title>
      <div :class="$style.caption">
        ニューヨーク・ヤンキースとタンパベイ・デビルレイズ（MLB ア・リーグ）は 東京ドームでシーズン開幕戦を行いました。
        前年に東京読売ジャイアンツからニューヨーク・ヤンキースに移籍した松井選手には凱旋の試合になりました。
        松井選手は31日の第2戦で、ジェレミー・ゴンザレス投手から開戦第1号の2ランホームランを放つなど活躍し、MVPに輝きました。
      </div>
      <div :class="[$style.fig2, $style.fig]"></div>
    </div>

    <div :class="[$style.third_area, $style.area]">
      <main-title
        :class="$style.main_title"
        :main_title="'3. ワールドシリーズMVPトロフィーリング'"
        :sub_title="'〜 2009年11月4月 〜'"
        :color="'#fff'"
        :align="'center'"
      ></main-title>
      <div :class="$style.caption">
        ヤンキースタジアムで行なわれた大リーグワールドシリーズ（7回戦制）の第6戦。 ヤンキース（アリーグ）はフィリーズ（ナリーグ）を7-3と破り、4勝2敗で9年ぶり27度目の優勝を決めました。
        この試合4打数3安打6打点と大活躍した松井選手。このシリーズ13打数8安打、打率.615、3本塁打8打点の成績を残し、 日本人選手初のシリーズ最優秀選手賞（MVP）に選ばれました。
      </div>
      <div :class="[$style.fig3, $style.fig]"></div>
      <div :class="[$style.fig3_1, $style.fig]"></div>
    </div>

    <div :class="[$style.fourth_area, $style.area]">
      <main-title
        :class="$style.main_title"
        :main_title="'4. 国民栄誉賞'"
        :sub_title="'〜 2013年5月5日 〜'"
        :color="'#fff'"
        :align="'center'"
      ></main-title>
      <div :class="$style.caption">
        東京ドームにおいて恩師長嶋茂雄氏とともに国民栄誉賞を受賞。
        授賞式とともに行われた松井秀喜現役引退セレモニーは、長嶋茂雄、松井秀喜、 師弟の不滅の絆を物語る光景としても話題を呼んだ。
      </div>
      <div :class="[$style.fig4, $style.fig]"></div>
      <div :class="[$style.fig4_1, $style.fig]"></div>
    </div>

    <div :class="[$style.fifth_area, $style.area]">
      <main-title
        :class="$style.main_title"
        :main_title="'5. 野球殿堂入り'"
        :sub_title="'〜 2018年7月13日 〜'"
        :color="'#fff'"
        :align="'center'"
      ></main-title>
      <div :class="$style.caption">
        京セラドームで行われたマイナビオールスターゲーム２０１８の試合前に野球殿堂入りの表彰式が行われ、プレーヤー表彰で巨人や米大リーグで通算507本塁打を収めたとして表彰された。
        表彰式では、巨人の後輩である坂本勇人選手から花束を渡され、野球殿堂博物館に飾られるレリーフの複製が授与された。
      </div>
      <div :class="[$style.fig5, $style.fig]"></div>
    </div>
  </section>
</template>

<script lang="ts">
import Vue from "vue";
import MainTitle from "@/components/atoms/MainTitle.vue";

export default Vue.extend({
  name: "AboutMedalVisual",

  components: {
    MainTitle
  }
});
</script>

<style lang="scss" module>
@media only screen and (max-width: 1023px) {
  #about_medal_visual {
    color: #fff;
    margin-top: 130px;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    .detail {
      width: 100%;
      text-align: center;
      height: 100vh;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
      flex-direction: column;
    }
    .first_area {
      margin-top: 40px !important;
    }
    .first_area,
    .second_area,
    .third_area,
    .fifth_area {
      .caption {
        top: 325px;
      }
    }
    .fourth_area {
      .caption {
        top: 425px;
      }
    }
    .area {
      margin-top: 200px;
      margin-bottom: 150px;
      height: 100vh;
      width: 300px;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      position: relative;
      .main_title {
        width: 100%;
      }
      .caption {
        width: 100%;
        text-align: center;
        font-size: 16px;
        margin-top: 40px;
        padding: 0px 40px;
        position: absolute;
      }
    }
    .fig {
      background-size: 180px 240px;
      background-repeat: no-repeat;
      height: 240px;
      width: 180px;
      // margin-top: 20px;
      position: absolute;
      margin-top: 70px;
      top: 25px;
    }
    @for $i from 1 through 5 {
      .fig#{$i} {
        background-image: url("../../../assets/img/medal/R#{$i}.png");
      }
    }
    .fig3 {
      background-size: 75px 75px;
      background-repeat: no-repeat;
      top: 100px;
      height: 75px;
      width: 75px;
      position: absolute;
      top: 135px;
      left: 175px;
      margin-top: 70px;
    }
    .fig3_1 {
      background-image: url("../../../assets/img/medal/R3_1.png");
      background-size: 75px 225px;
      background-repeat: no-repeat;
      height: 225px;
      width: 75px;
      margin-top: 20px;
      position: absolute;
      top: 30px;
      right: 160px;
      margin-top: 70px;
    }
    .fig4_1 {
      background-image: url("../../../assets/img/medal/R4_1.png");
      background-size: 300px 75px;
      background-repeat: no-repeat;
      height: 75px;
      width: 300px;
      margin-top: 20px;
      position: absolute;
      top: 280px;
      margin-top: 70px;
    }
  }
}

@media only screen and (min-width: 1024px) {
  #about_medal_visual {
    color: #fff;
    margin-top: 130px;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    .detail {
      width: 100%;
      text-align: center;
      height: 100vh;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
      flex-direction: column;
    }
    .first_area {
      margin-top: 40px !important;
    }
    .area {
      margin-top: 200px;
      height: 100vh;
      width: 700px;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      position: relative;
      .main_title {
        margin-top: 70px;
        width: 100%;
      }
      .caption {
        width: 100%;
        text-align: center;
        font-size: 23px;
        margin-top: 40px;
        padding: 0px 40px;
        position: absolute;
        top: 150px;
      }
    }
    .fig {
      background-size: 300px 400px;
      background-repeat: no-repeat;
      height: 400px;
      width: 300px;
      // margin-top: 20px;
      position: absolute;
      top: 450px;
    }
    @for $i from 1 through 5 {
      .fig#{$i} {
        background-image: url("../../../assets/img/medal/R#{$i}.png");
      }
    }
    .fig3 {
      background-size: 100px 100px;
      background-repeat: no-repeat;
      top: 100px;
      height: 100px;
      width: 100px;
      position: absolute;
      top: 500px;
      left: 175px;
    }
    .fig3_1 {
      background-image: url("../../../assets/img/medal/R3_1.png");
      background-size: 100px 300px;
      background-repeat: no-repeat;
      height: 300px;
      width: 100px;
      margin-top: 20px;
      position: absolute;
      top: 400px;
      right: 160px;
    }
    .fig4_1 {
      background-image: url("../../../assets/img/medal/R4_1.png");
      background-size: 600px 150px;
      background-repeat: no-repeat;
      height: 150px;
      width: 600px;
      margin-top: 20px;
      position: absolute;
      top: 825px;
    }
  }
}
</style>
